module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "resultsRef"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Log for " + _vm._s(_vm.app.name) + " (" + _vm._s(_vm.app.id) + ")")])])]), _vm._v(" "), (_vm.showEditor) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.textBlock,
      "width": _vm.textBlockWidth,
      "height": _vm.textBlockHeight,
      "readonly": _vm.textBlockReadOnly,
      "scrollToLine": _vm.scrollToLine,
      "lang": _vm.textBlockLang
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Number of log records: " + _vm._s(_vm.numLogs))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn",
    class: {
      'btn-primary': !_vm.disableStart
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableStart
    },
    on: {
      "click": _vm.openWs
    }
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'btn-primary': !_vm.disableStop
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableStop
    },
    on: {
      "click": _vm.closeWs
    }
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearLogs
    }
  }, [_c('i', {
    staticClass: "fa fa-bomb",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('feedback', {
    attrs: {
      "id": "feedback",
      "message": _vm.message,
      "spin": _vm.showSpinner,
      "success": _vm.success
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fecf2e2e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppLogs.vue
// module id = 600
// module chunks = 2